'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { StaticFallback } from './static-fallback';
import { useShouldShowGame } from './use-should-show-game';
const Sign404Shell = dynamic(() => import('./sign-404-shell').then(m => m.Sign404Shell), {
  ssr: false,
  loading: () => <StaticFallback />
});
export function NotFoundPage() {
  const $ = _c(2);
  const {
    ready,
    show
  } = useShouldShowGame();
  if (!ready || !show) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <StaticFallback />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Sign404Shell data-sentry-element="Sign404Shell" data-sentry-component="NotFoundPage" data-sentry-source-file="not-found-page.tsx" />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}